import {provideEventPlugins} from "@taiga-ui/event-plugins";
import {provideAnimations} from "@angular/platform-browser/animations";
import {ApplicationConfig, signal} from '@angular/core';
import {provideRouter} from '@angular/router';
import {routes} from './app.routes';
import {provideToastr} from 'ngx-toastr';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {errorInterceptor} from './shared/interceptors/error.interecepter';
import {mainInterceptor} from './shared/interceptors/main.interceptor';
import {TUI_LANGUAGE, TUI_RUSSIAN_LANGUAGE} from '@taiga-ui/i18n';
import {of} from 'rxjs';
import {provideTaiga} from '@taiga-ui/core';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideTaiga( {
      mode: 'light',
    }),
    provideHttpClient(
      withInterceptors([mainInterceptor, errorInterceptor])
    ),
    provideToastr(),
    provideRouter(routes),
    provideEventPlugins(),
    {
      provide: TUI_LANGUAGE,
      useValue: signal(TUI_RUSSIAN_LANGUAGE),
    }
  ]
};
